import React from 'react';
import { CHECKOUT_URL } from '../../data/content';
export function Hero() {
  return <header className="w-full bg-bone px-4 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-10" data-id="element-203" data-mp="7whypikp34kj">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center" data-id="element-204" data-mp="cvumq6nayhop">
        <p className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-[0.22em] text-ink" data-id="element-205" data-mp="cy7dn9b1g2dw">
          <span aria-hidden="true" data-id="element-206" data-mp="mu0ngkxdhhrz">🩺</span>
          Dr. <span className="text-blood" data-id="element-207" data-mp="mt92s55bd4gh">Karito</span>
        </p>

        <h1 className="mt-6 font-display text-[30px] font-extrabold leading-[1.1] tracking-tight text-ink sm:text-5xl lg:text-[56px]" data-id="element-208" data-mp="qvdw12runz2l">
          Solve every case of hypertension with a clear clinical route in just{' '}
          <em className="italic text-blood" data-id="element-209" data-mp="10loyslzss27w">5 minutes</em> of consultation
        </h1>

        <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-graphite/80 sm:text-lg" data-id="element-210" data-mp="15l1ulw8ncjmm">
          Stop improvising when complex patients are in front of you. Follow a
          practical clinical route that shows you exactly what to do — from
          diagnosis and treatment to adjustment and long-term follow-up — backed
          by the latest clinical guidelines.
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/iX4dC38TJqaTTeMUBESA6a/HIPETENSION-EN.png" alt="Hypertension Route: box set of 6 clinical volumes, quick-reference guide, checklists and digital edition on tablet and phone" className="mt-7 w-full max-w-[560px]" width={1080} height={1080} data-id="element-211" data-mp="3vur74pfi5cwm" />

        <p className="mt-2 max-w-xl text-[13px] font-bold uppercase tracking-[0.1em] text-graphite/70 sm:text-sm" data-id="element-212" data-mp="nfzfpiz0uoga">
          6 Clinical Volumes · Quick-Reference Guides · Checklists · Digital
          Edition
        </p>

        <div id="hero-cta" className="mt-7 flex w-full flex-col items-center" data-id="element-213" data-mp="el2vzwhodte6">
          <a href={CHECKOUT_URL} data-cta="hero" className="animate-pulse-ring flex w-full max-w-md items-center justify-center gap-2 rounded-xl bg-blood px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-cta transition-[background-color,transform] duration-200 ease-out hover:bg-bloodDark active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blood sm:text-base" data-id="element-214" data-mp="1b637mt2ukzrg">
            <span aria-hidden="true" data-id="element-215" data-mp="2hvfsaqglshld">🔴</span> I want my Hypertension Route now
          </a>
          <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.08em] text-graphite/65 sm:text-xs" data-id="element-216" data-mp="2muium35789pn">
            Instant access · One-time payment · Lifetime access · 7-day
            guarantee
          </p>
        </div>

        <p className="mt-7 max-w-xl border-t border-ink/10 pt-6 text-[13px] leading-relaxed text-graphite/70 sm:text-sm" data-id="element-217" data-mp="2cvjn4nw66k48">
          Trusted by{' '}
          <strong className="font-bold text-ink" data-id="element-218" data-mp="63sm9f5vksqi">2,000+ physicians</strong> who
          use Hypertension Route to make clinical decisions faster, with greater
          confidence and clarity.
        </p>
      </div>
    </header>;
}